import styled from 'styled-components';

/* fundo e cor quando ativo */
export const Container = styled.div`
  background: ${({ isActive }) => (isActive ? '#d7f0fc' : 'transparent')};
  color:      ${({ isActive }) => (isActive ? '#27aae1' : '#000')};
`;

export const ContentItem = styled.li`
  list-style: none;
  padding: ${({ courseLevel }) => (courseLevel ? '0 15px' : '0')};
  font-size: ${({ courseLevel }) => (courseLevel ? 'inherit' : '14px')};
`;

export const ContentItemChild = styled.div`
  display: flex;
  align-items: center;      /* ícone e texto centralizados verticalmente */
  width: 100%;
  padding: ${({ courseLevel }) => (courseLevel ? '0' : '7px 15px')};
  margin-bottom: ${({ courseLevel }) => (courseLevel ? '15px' : '0')};
  cursor: ${({ available }) => (available ? 'pointer' : 'not-allowed')};

  .info {
    color: ${({ courseLevel }) => (courseLevel ? '#4A5057' : '#000')};
    font-weight: ${({ courseLevel }) => (courseLevel ? 'normal' : 'bold')};
    line-height: 18px;
  }
`;

export const ContainerIcon = styled.div`
  flex-shrink: 0;
  width: ${({ courseLevel }) => (courseLevel ? '48px' : '38px')};
  height: ${({ courseLevel }) => (courseLevel ? '48px' : '38px')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background: #27aae1;
  font-size: 18px;
  color: #fff;
  margin: ${({ courseLevel }) => (courseLevel ? '0 10px 0 0' : '0 13px 0 10px')};
`


export const ActionIcon = styled.div`
  margin-left: auto;
  font-size: 0.8rem;
  color: #27aae1;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ courseLevel }) => (courseLevel ? '20px 0' : '0')};
`;

export const Status = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #1b6b3a;
  margin-top: 2px;

  svg {
    margin-right: 4px;
  }
`;
